<style lang="scss"></style>

<template>
  <!-- eslint-disable -->
  <div class="mb-4">
    <section class="full-width d-flex justify-content-end">
      <b-btn variant="primary" :to="{name: 'post-replies'}">Upload Reply</b-btn>
    </section>
    <section class="my-2">
      <h4>Filters</h4>

      <div class="row">
        <section class="col-3">
          <label>{{'prisoner' | term(true)}} Number</label>
          <b-form-input
            @keyup.enter="searchReplies()" cy="prison-number"
            @input="filters.prisoner_number = filters.prisoner_number.toUpperCase()"
            v-model="filters.prisoner_number"
            class="mb-1" :placeholder="'Enter ' + $options.filters.term('prisoner') + ' number'"
          />
        </section>

        <section class="col-3">
          <label>Sort</label>
          <b-form-select @change="searchReplies()" v-model="filters.sort" class="mb-1" cy="sort">
            <b-form-select-option value="updated_at">Updated (Oldest First)</b-form-select-option>
            <b-form-select-option value="-updated_at">Updated (Newest First)</b-form-select-option>
            <b-form-select-option value="prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (A-Z)</b-form-select-option>
            <b-form-select-option value="-prisoner_number">{{ $options.filters.term('prisoner') | capEachWord }} Number (Z-A)</b-form-select-option>
            <b-form-select-option value="visitor.firstname">Visitor Name (A-Z)</b-form-select-option>
            <b-form-select-option value="-visitor.firstname">Visitor Name (Z-A)</b-form-select-option>
          </b-form-select>
        </section>

        <section class="col-3">
          <label>From Date</label>
          <b-form-datepicker v-model="filters.after" locale="en-uk" cy="after"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-3">
          <label>End Date</label>
          <b-form-datepicker v-model="filters.before" locale="en-uk" cy="before"
                             today-button
                             reset-button
                             close-button
                             :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
          ></b-form-datepicker>
        </section>

        <section class="col-12 d-flex align-items-center full-width" style="margin-top: 5px">
          <b-button @click="clearFilters()">Clear filters</b-button>
          <b-button class="btn-success ml-1" @click="searchReplies()">Search</b-button>
          <div class="ui-spacer"></div>
          <b-button @click="searchReplies()"><i class="fas fa-sync"></i></b-button>
        </section>
      </div>
    </section>

    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="replies"
          :fields="headers"
          :current-page="currentPage"
          :per-page="null"
          ref="selectableTable"
          :select-mode="'multi'"
        >
          <template #cell(updated_at)="data">
            {{data.item.updated_at | formatDateTime}}
          </template>

          <template #cell(visitorName)="data">
            {{data.item.visitor.firstname}} {{data.item.visitor.lastname}}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'post-view', params: { id: data.item._id } }" class="font-weight-bold d-block text-nowrap">
              View
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination @change="getReplies()" :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No records</p>
        </b-row>
      </section>
    </b-card>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import PostService from '@/services/PostService'
import HelperService from '../../services/HelperService';

export default {
  name: 'PostReplySearch',
  components: {},
  data() {
    return {
      helperService: new HelperService(),
      loading: true,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: 'Contact', key: 'visitorName' },
        { label: 'Updated', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
      replies: [],
      currentPage: 1,
      totalRows: 10,
      filters: {
        limit: 10,
        prisoner_number: '',
        before: '',
        after: '',
        skip: 1,
        sort: '-updated_at',
      },
    };
  },
  computed: {},
  watch: {
    currentPage() {
      this.getReplies();
    },
    $route() {
      this.setUp();
    },
  },
  mounted() {
    this.setUp();
  },
  methods: {
    setUp() {
      this.getReplies();
    },
    searchReplies() {
      this.currentPage = 1;

      this.getReplies();
    },
    getReplies() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;

      PostService.getReplies(this.filters).then(res => {
        this.loading = false;
        this.replies = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting replies ', err);
        this.$toast.error('Could not get failed replies, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    clearFilters() {
      this.filters = {
        status: '',
        prisoner_number: '',
        before: '',
        after: '',
        skip: 1,
        sort: '-updated_at',
      };

      this.searchReplies();
    },
  },
};
</script>
